const t = {
  name: "Attachment",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.7929 5.20706C17.6981 3.1123 14.3019 3.1123 12.2071 5.20705L3.70708 13.7071C2.44075 14.9734 2.44074 17.0265 3.70705 18.2929C4.97338 19.5592 7.02654 19.5592 8.29288 18.2929L16.7929 9.7929C17.2308 9.355 17.2308 8.64504 16.7929 8.20713C16.355 7.76922 15.645 7.76921 15.2071 8.20712L6.99999 16.4142L5.58578 14.9999L13.7929 6.7929C15.0118 5.57394 16.9882 5.57396 18.2071 6.79294C19.426 8.0119 19.426 9.98818 18.2071 11.2071L9.7071 19.7071C7.6597 21.7545 4.3402 21.7545 2.29282 19.7071C0.245476 17.6597 0.245494 14.3402 2.29286 12.2929L10.7929 3.79284C13.6687 0.917032 18.3313 0.917037 21.2071 3.79284C24.0829 6.66865 24.0829 11.3313 21.2071 14.2071L17 18.4142L15.5858 16.9999L19.7929 12.7928C21.8876 10.6981 21.8876 7.30181 19.7929 5.20706Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Attachment
};
